<template>
    <div class="build-your-box w-100 d-flex flex-wrap justify-content-center py-4 px-3">

        <!-- Título -->
        <div class="w-100 text-center mb-3">
            <h2 class="box-title fw-bold">ARMA TU BOX</h2>
            <p class="box-subtitle">9 piezas · 3 tercios · Tú decides</p>
        </div>

        <!-- Caja visual cenital -->
        <BoxVisual
            :thirds="thirds"
            :products="products"
            @select-third="onSelectThird"
            @remove-third="onRemoveThird"
        />

        <!-- Selector de producto (si hay tercio activo sin producto) -->
        <div class="w-100 mt-3" v-if="activeThirdIndex !== null && !thirds[activeThirdIndex].product">
            <p class="text-center selector-label mb-2">
                {{ activeThirdIndex === 0 ? 'Elige tu primer tercio:' : activeThirdIndex === 1 ? 'Elige tu segundo tercio:' : 'Elige tu último tercio:' }}
            </p>
            <ProteinSelector
                :products="products"
                @select="onSelectProduct"
            />
        </div>

        <!-- Resumen cuando está completa -->
        <BoxSummary
            v-if="isComplete"
            :thirds="thirds"
            :products="products"
            :price="599"
            @reset="onReset"
        />

        <!-- Botón empezar de nuevo (si hay algo pero no está completa) -->
        <div class="w-100 text-center mt-2" v-if="hasContent && !isComplete">
            <button class="btn-reset" @click="onReset">Empezar de nuevo</button>
        </div>

        <!-- Modal variante -->
        <VariantModal
            v-if="showVariantModal"
            :product="selectedProduct"
            @confirm="onConfirmVariant"
            @close="showVariantModal = false"
        />
    </div>
</template>

<script>
import BoxVisual from './BoxVisual.vue';
import ProteinSelector from './ProteinSelector.vue';
import BoxSummary from './BoxSummary.vue';
import VariantModal from './VariantModal.vue';

const BOX_PRODUCTS = {
    big_mary: {
        id: 'big_mary',
        name: "Big Mary's",
        image: require('@/assets/images/box/big-mary.png'),
        unitLabel: 'sándwich',
        unitLabelPlural: 'sándwiches',
    },
    tenders: {
        id: 'tenders',
        name: 'Tenders',
        image: require('@/assets/images/box/tenders.png'),
        unitLabel: 'tender',
        unitLabelPlural: 'tenders',
    },
    bone_chicken: {
        id: 'bone_chicken',
        name: 'Signature Chicken',
        image: require('@/assets/images/box/bone-chicken.png'),
        unitLabel: 'pieza',
        unitLabelPlural: 'piezas',
    },
};

export default {
    name: 'BuildYourBox',
    components: { BoxVisual, ProteinSelector, BoxSummary, VariantModal },
    data() {
        return {
            products: BOX_PRODUCTS,
            thirds: [
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
            ],
            activeThirdIndex: 0,
            showVariantModal: false,
            selectedProduct: null,
        };
    },
    computed: {
        isComplete() {
            return this.thirds.every(t => t.product !== null);
        },
        hasContent() {
            return this.thirds.some(t => t.product !== null);
        },
    },
    methods: {
        onSelectThird(index) {
            this.activeThirdIndex = index;
        },
        onSelectProduct(productId) {
            this.selectedProduct = this.products[productId];
            this.showVariantModal = true;
        },
        onConfirmVariant(variant) {
            this.showVariantModal = false;
            if (this.activeThirdIndex === null) return;

            this.thirds[this.activeThirdIndex] = {
                product: this.selectedProduct.id,
                variant: variant,
            };

            // Avanzar al siguiente tercio vacío
            const nextEmpty = this.thirds.findIndex((t, i) => i > this.activeThirdIndex && t.product === null);
            if (nextEmpty !== -1) {
                this.activeThirdIndex = nextEmpty;
            } else {
                const firstEmpty = this.thirds.findIndex(t => t.product === null);
                this.activeThirdIndex = firstEmpty !== -1 ? firstEmpty : null;
            }
        },
        onRemoveThird(index) {
            this.thirds[index] = { product: null, variant: 'normal' };
            this.activeThirdIndex = index;
        },
        onReset() {
            this.thirds = [
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
            ];
            this.activeThirdIndex = 0;
        },
    },
};
</script>

<style scoped>
.build-your-box {
    max-width: 600px;
    margin: 0 auto;
}

.box-title {
    font-size: 28px;
    color: var(--primary);
    letter-spacing: 2px;
}

.box-subtitle {
    font-size: 14px;
    color: var(--text11);
    margin-top: 4px;
}

.selector-label {
    font-size: 16px;
    font-weight: 600;
    color: var(--text6);
}

.btn-reset {
    background: none;
    border: none;
    color: var(--text11);
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
    padding: 8px 16px;
}

.btn-reset:hover {
    color: var(--primary);
}
</style>
